<div class="product-info-container">
  <h2 class="product-info-title">{{productInfoTitle}}</h2>
  @if (productInfoSection) {
    <p>{{productInfoSection}}</p>
  }
</div>